import { DOCUMENT } from '@angular/common';
import { Component, inject, Inject, isDevMode, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { StorageService } from '@shared/services';
import { TranslateService } from '@shared/services/translate';
import { Subject, takeUntil } from 'rxjs';
import { MatIcon } from '@angular/material/icon';



@Component({
    selector: 'shopbox-root',
    templateUrl: './app.component.html',
    providers: [StorageService],
    imports: [RouterOutlet, MatIcon]
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _storage = inject(StorageService);
  private readonly _activeRoute = inject(ActivatedRoute);
  readonly translate = inject(TranslateService);
  progress = signal<boolean>(true);
  isLoginDone = signal<boolean>(false);
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor( @Inject(DOCUMENT) private _document: HTMLDocument) {
    this.isLoginDone.set(false);
    this.getEnv();
  }

  ngOnInit() {
    window.addEventListener('storage', (event) => this.changeLoginValue(event));
    // TODO update if find better way :(
    this._activeRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if(res.lang) {
        this.translate.use(res.lang);
      }
    })
  }

  getEnv() {
    const appFaviconIE = this._document.getElementById('appFaviconIE');
    const appFaviconOther = this._document.getElementById('appFaviconOther');
    if (!isDevMode()) {
      if (appFaviconIE) {
        appFaviconIE.setAttribute('href', './../assets/core/favicon-32x32.png');
        appFaviconIE.setAttribute('type', 'image/png');
      }
      if (appFaviconOther) {
        appFaviconOther.setAttribute('href', './../assets/core/favicon-32x32.png');
        appFaviconOther.setAttribute('type', 'image/png');
      }
    } else {
      if (appFaviconIE) {
        appFaviconIE.setAttribute('href', './../favicon.ico');
        appFaviconIE.setAttribute('type', 'image/x-icon');
      }
      if (appFaviconOther) {
        appFaviconOther.setAttribute('href', './../favicon.ico');
        appFaviconOther.setAttribute('type', 'image/x-icon');
      }
    }
  }

  changeLoginValue(event: any) {
    const tokenStorage = this._storage.getToken();
    if (event && event.storageArea && !tokenStorage && !this.isAuthRoutes()) {
       location.reload();
    } else if (this.isAuthRoutes() && this._storage.isAuthorized() && !this._storage.getIsApp() && this.isLoginDone()) {
      location.reload();
    }
    if (event && event.storageArea && event.storageArea.__ocurk) {
      this.isLoginDone.set(true);
    } else {
      this.isLoginDone.set(false);
    }
  }

  isUnauthenticatedRoutes(url: string) {
    const arrayLinks = ['login', 'signup', 'reset', 'registe'];
    const filterArr = arrayLinks.filter(element => url.includes(element));
    return filterArr.length > 0;
  }

  isAuthRoutes(): boolean {
    const url = location.hash;
    return this.isUnauthenticatedRoutes(url);
  }

  onActive() {
    this.progress.set(false);
  }

  ngOnDestroy() {
    document.removeEventListener('visibilitychange', () => {}, false);
    window.removeEventListener('storage', () => {}, false);
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
